import posed from 'react-pose';
import React from 'react';
import { createPureComponent } from 'module/Common';

type AnimatedPathProps<Pose extends string = string> = React.SVGProps<SVGPathElement> & { pose: Pose };

const posePath = <Pose extends string>(poses: { [K in Pose]: any }): React.SFC<AnimatedPathProps<Pose>> =>
  posed.path(poses) as any;

const Path1 = posePath({
  closed: {
    rotate: 0,
    y: -6,
  },
  open: {
    rotate: 225,
    y: 0,
  },
});

const Path2 = posePath({
  closed: {
    rotate: 0,
  },
  open: {
    rotate: 225,
  },
});

const Path3 = posePath({
  closed: {
    rotate: 0,
    y: 6,
  },
  open: {
    rotate: 135,
    y: 0,
  },
});

type Props = {
  height?: number;
  open: boolean;
};

export const MenuIcon = createPureComponent<Props>('MenuIcon', ({ height = 30, open }) => {
  return (
    <svg width={height * 2} height={height} viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" fill="none" fillRule="evenodd">
        {/* <rect id="Rectangle" fill="#D8D8D8" width="60" height="30" /> */}
        <g id="Group" transform="translate(14 6)" fill="#241770">
          <Path1
            pose={open ? 'open' : 'closed'}
            d="M31,10 L1,10 C0.447,10 0,9.552 0,9 C0,8.448 0.447,8 1,8 L31,8 C31.553,8 32,8.448 32,9 C32,9.552 31.553,10 31,10"
            id="Fill-1"
          />
          <Path2
            pose={open ? 'open' : 'closed'}
            d="M31,10 L1,10 C0.447,10 0,9.552 0,9 C0,8.448 0.447,8 1,8 L31,8 C31.553,8 32,8.448 32,9 C32,9.552 31.553,10 31,10"
            id="Fill-3"
          />
          <Path3
            pose={open ? 'open' : 'closed'}
            d="M31,10 L1,10 C0.447,10 0,9.552 0,9 C0,8.448 0.447,8 1,8 L31,8 C31.553,8 32,8.448 32,9 C32,9.552 31.553,10 31,10"
            id="Fill-5"
          />
        </g>
      </g>
    </svg>
  );
});



// WEBPACK FOOTER //
// ./src/module/View/Menu/icons/MenuIcon.tsx